export const DELETION_TARGETS = {
  MEMBER: 'member',
  SELF: 'self',
  INVITE: 'invite',
} as const;

export type DeletionTarget =
  (typeof DELETION_TARGETS)[keyof typeof DELETION_TARGETS];
